module.exports = __webpack_public_path__ + "img/home-bg.b18d6511.png";